// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"372":"e98e391a","734":"1b4eb9a2","934":"46428f58"}[chunkId] + ".js";
};